// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__efy1y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 144
// module chunks = 0